export default __webpack_public_path__ + "static/media/pic.b905fb32.svg";